export default __webpack_public_path__ + "static/media/Lavinraca_Ria_1_by_guide_of_hunteres.96e5164a.png";